import { withRouter } from 'react-router';
import MissedDepartureCta from './MissedDepartureCta';

export default withRouter(MissedDepartureCta);
